import {
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  setDoc,
  where,
} from "firebase/firestore";

export const useJiraTickets = () => {
  const fetchJiraTickets = async (showCounts: boolean) => {
    const db = useFirestore();
    const jiraTicketsRef = collection(db, "jiraTickets");
    const jiraTicketsQuery = query(
      jiraTicketsRef,
      orderBy("identifier", "asc")
    );

    const jiraTicketsSnapshot = await getDocs(jiraTicketsQuery);

    const tickets = jiraTicketsSnapshot.docs.map((doc) => {
      const ticket = {
        ...doc.data(),
      } as JiraTicket;

      ticket.label = `${ticket.identifier} - ${ticket.description}: (${
        ticket.numTests ?? 0
      })`;

      return ticket;
    });

    if (showCounts) {
      // sort by numTests
      tickets.sort((a, b) => {
        if (a.numTests && b.numTests) {
          return b.numTests - a.numTests;
        }
        return 0;
      });
    }

    return tickets;
  };

  const saveJiraTicket = async (jiraTicket: JiraTicket) => {
    const db = useFirestore();
    const jiraTicketsRef = doc(db, `/jiraTicekt/${jiraTicket.identifier}`);
    await setDoc(jiraTicketsRef, jiraTicket);
  };

  return { fetchJiraTickets, saveJiraTicket };
};
